class RoutineFiltersComponent extends HTMLElement {
 connectedCallback() {
  this.filterButtons = this.querySelectorAll('[data-filter-type]');

  this.filterButtons.forEach((button) => {
   button.addEventListener('click', this.onFilterClick.bind(this));
  });
 }

 /**
  * @param {Event} event
  */
 onFilterClick(event) {
  const clickedButton = event.currentTarget;
  if (!(clickedButton instanceof HTMLElement)) return;
  const type = clickedButton.dataset.filterType || '';
  const items = document.querySelectorAll('.product-grid__item');

  // Update active class
  this.filterButtons?.forEach((btn) => btn.classList.remove('active'));
  clickedButton.classList.add('active');

  // Filter items
  items.forEach((item) => {
   if (!(item instanceof HTMLElement)) return;
   const tags = item.dataset.productTags ? item.dataset.productTags.split(',') : [];
   if (type === 'all' || tags.includes(type)) {
    item.classList.remove('hidden');
    item.style.display = '';
   } else {
    item.classList.add('hidden');
    item.style.display = 'none';
   }
  });
 }
}

if (!customElements.get('routine-filters')) {
 customElements.define('routine-filters', RoutineFiltersComponent);
}